import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import classNames from 'classnames';
import Slice from "./Slice";

class Figure extends Component {
  constructor(props) {
    super(props);

    this.state = {
      imageLoaded: false,
    }
  }

  imageLoaded = () => {
    this.setState({
      imageLoaded: true,
    });
  };

  render() {
    const {classes, imageSrc, imageAlt, width, height, caption, className} = this.props;

    return (
      <figure className={classNames(classes.figure, className)}>
        {(width && height) ? (
          <div className={classes.wrapper} style={{paddingBottom: `${height / width * 100}%`}}>
            <div className={classNames(classes.overlay,
              {[`${classes.dissolved}`]: this.state.imageLoaded}
            )}/>
            <img src={imageSrc}
                 alt={imageAlt}
                 onLoad={this.imageLoaded}
                 className={classNames(classes.image, {[`${classes.hidden}`]: !this.state.imageLoaded})}
            />
          </div>
        ) : (
          <img src={imageSrc}
               alt={imageAlt}
               className={classes.image}
          />
        )
        } {
        caption
        && (
          <Slice>
            <figcaption className={classes.figCaption}>{caption}</figcaption>
          </Slice>
        )
      }

      </figure>
    );
  }
}


export default withStyles(theme => ({
  figure: {
  },
  figCaption: {
    ...theme.typography.hg14i(theme),
    color: theme.palette.secondary.light,
    textAlign: 'center',
    marginTop: '1em',
    maxWidth: theme.layout.containerMaxWidth,
    margin: '0 auto',
  },
  image: {
    display: 'block',
    width: '100%',
    height: 'auto',
  },
  wrapper: {
    position: 'relative',
    width: '100%',
    background: theme.palette.primary.light,
    overflow: 'none',
    '& img': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    }
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: theme.palette.primary.light,
    zIndex: 1,
    transition: 'background 1s ease-out',
  },
  dissolved: {
    background: 'transparent',
  },
  hidden: {
    display: 'none',
  },
}))(Figure);


// WEBPACK FOOTER //
// ./src/parts/Figure.js